export class Messages {
  automaticRechargeOnly: string;
  automaticRechargeTriggerWarning: string;

  constructor(messagesData: any) {
    this.automaticRechargeOnly = messagesData.automaticRechargeOnly;
    this.automaticRechargeTriggerWarning = messagesData.automaticRechargeTriggerWarning;
  }
}
